/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { AuditLogDto } from './AuditLogDto';
import {
    AuditLogDtoFromJSON,
    AuditLogDtoFromJSONTyped,
    AuditLogDtoToJSON,
    AuditLogDtoToJSONTyped,
} from './AuditLogDto';

/**
 * Response containing a paginated list of audit log entries
 * @export
 * @interface AuditLogListResponse
 */
export interface AuditLogListResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditLogListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof AuditLogListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof AuditLogListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof AuditLogListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * List of audit log entries
     * @type {Array<AuditLogDto>}
     * @memberof AuditLogListResponse
     */
    data?: Array<AuditLogDto>;
    /**
     * Total number of audit log entries matching the criteria
     * @type {number}
     * @memberof AuditLogListResponse
     */
    total?: number;
    /**
     * Current page number
     * @type {number}
     * @memberof AuditLogListResponse
     */
    page?: number;
    /**
     * Number of entries per page
     * @type {number}
     * @memberof AuditLogListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the AuditLogListResponse interface.
 */
export function instanceOfAuditLogListResponse(value: object): value is AuditLogListResponse {
    return true;
}

export function AuditLogListResponseFromJSON(json: any): AuditLogListResponse {
    return AuditLogListResponseFromJSONTyped(json, false);
}

export function AuditLogListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditLogListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AuditLogDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function AuditLogListResponseToJSON(json: any): AuditLogListResponse {
    return AuditLogListResponseToJSONTyped(json, false);
}

export function AuditLogListResponseToJSONTyped(value?: AuditLogListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AuditLogDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

